module.exports = __webpack_public_path__ + "img/bg.05fde63a.png";